import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import themes from '@/js/themes'
import { store } from '@/store/store'
// import 'vuetify/src/stylus/app.styl'
// import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    dark: store.state.themeDark,
    themes: themes[store.state.theme].themes,
    options: {
      customProperties: true // this makes css variables like (--v-color1-base) work
    }
  },
  icons: {
    iconfont: 'mdi',
  }
}

export default new Vuetify(opts)
